module.exports = __webpack_public_path__ + "static/media/wireframing_img1.f30c4461.png";